import { Component } from '@angular/core';
import { NbAccessChecker } from '@nebular/security';
import {TranslateService} from '@ngx-translate/core';
@Component({
  selector: 'ngx-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent {

}
